import { Component, OnInit, signal, computed, AfterViewInit } from '@angular/core';
import { CardServicesComponent } from "../../shared/card-services/card-services.component";
import { RouteService } from '../../services/route.service';
import { SecurityService } from '../../services/security.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../services/loader.service';
import { HelpService } from '../../services/help.service';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [
    CardServicesComponent
  ],
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent implements OnInit, AfterViewInit{
  itemsSelected = signal<string[]>([]);
  nextRoute = signal('');
  services = signal([
    { label: 'Crédito', value: 'credito', img: 'img/cell.png', enabled: false },
    { label: 'Ahorro', value: 'ahorro', img: 'img/savings.png', enabled: false },
    { label: 'Inversion', value: 'inversion', img: 'img/invest.png', enabled: false },
    { label: 'Seguro', value: 'seguro', img: 'img/umbrella.png', enabled: false },
    { label: 'Beneficios', value: 'beneficios', img: 'img/tickets.png', enabled: false },
    { label: 'Vinculación', value: 'vinculacion', img: 'img/hands.png', enabled: false },
  ]);

  enabledButton = computed(() => this.itemsSelected().length > 0);

  constructor(
    private _router: Router,
    private _routeService: RouteService,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _helpService: HelpService
  ) { 
    this.getServices();
  }

  ngOnInit(): void {
    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
    this._helpService.show();
  }

  ngAfterViewInit(): void {
    this._loaderService.hide();
  }

   getServices() {
    this._loaderService.show();
    this._securityService.getServices().subscribe({
      next: (response: any) => {
        this.services.set(this.services().map(service => {
          const isEnabled = response.activeServices.includes(service.value);
          return { ...service, enabled: isEnabled };
        }));
        this.itemsSelected.set(response.activeServices || []);
        this._loaderService.hide();
      },
      error: (error: any) => {
        console.error('Error fetching services:', error);
        this._loaderService.hide();
      }
    });
   }

  onCardClick(event: string) {
    const current = this.itemsSelected();
    const index = current.findIndex(id => id === event);

    if (index > -1) {
      this.itemsSelected.set([
        ...current.slice(0, index),
        ...current.slice(index + 1)
      ]);
    } else {
      this.itemsSelected.set([...current, event]);
    }
  }

  onNextClick() {
    this._loaderService.show();
    this._securityService.setActiveServices(this.itemsSelected()).subscribe({
      next: () => {
        this._router.navigateByUrl(this.nextRoute());
      },
      error: (error: any) => {
        console.error('Error saving selected services:', error);
        this._loaderService.hide();
      }
    });
  }
}
